module.exports = __webpack_public_path__ + "static/img/李亮名片PC.766250b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/contact/李亮名片PC.jpg
// module id = 7Rkj
// module chunks = 1